<template>
  
    <div>
      <div v-if="isEaf">
        <div>
          <b-link v-if="chunk.number > 0 && prevButton" class="colorBlue" @click="getChunk(-1)">❮••</b-link>
          
          <span  v-for="ch of chunks" :key="ch.id" :id="ch.id" class="chunkText udm-font">
              <Chunkword v-for="word in ch.translate.chunkwords" :key="word.id" :chunk="chunk" :word="word" :filter="filter"/>
              <span style="width:4px;display:inline-block;">&nbsp;</span>
          </span>

          <b-link v-if="nextButton" class="colorBlue" @click="getChunk(1)">••❯</b-link>
        </div>

        <div v-if="chunk.translate.translate" class="translate mt-2">
          <span v-for="ch of chunks" :key="ch.id" :id="chunk.id" class="chunkText">
              {{ ch.translate.translate.body }}
              <!-- <Chunkword v-for="word in chunk.translate.translate.chunkwords" :key="word.id" :word="word" :filter="filter"/> -->
              <span style="width:4px;display:inline-block;">&nbsp;</span>
          </span>
        </div>
      </div>

      <div v-else>
        <b-link v-if="chunk.number > 0 && prevButton" class="colorBlue" @click="getChunk(-1)">❮••</b-link>

        <span v-for="chunk of chunks" :key="chunk.id" :id="chunk.id" class="chunkText">
            <Chunkword v-for="word in chunk.chunkwords" :key="word.id" :chunk="chunk" :word="word" :filter="filter"/>
            <span style="width:4px;display:inline-block;">&nbsp;</span>
        </span>

        <b-link v-if="nextButton" class="colorBlue" @click="getChunk(1)">••❯</b-link>
      </div>

    </div>

</template>

<script>
import { searchService } from '@/_services'
import ChunkContent from './ChunkContent'
import Chunkword from './Chunkword'
export default {
  name: "ChunkContent",
  components:{
    ChunkContent,
    Chunkword
  },
  props: {
      chunk: {
          type: Object,
          default: null
      },
      filter: {
          type: Object,
          default: null
      }
  },
  data(){
    return {
      chunks: [],
      prevButton: true,
      nextButton: true
    }
  },
  mounted() {
    this.chunks = []
    this.chunks.push(this.chunk)
  },
  computed: {
    isEaf(){
      return this.chunk.publication.file.toLowerCase().endsWith('.eaf')
    }
  },

  methods: {
    getChunk(mode){
      searchService.getChunk(this.chunk,mode)
      .then(
        data => {
          if (mode == -1) {
            this.prevButton = false;

            data.chunkwords[data.chunkwords.length-1].hasSpace = true;
            let brCount = data.chunkwords.filter(word => word.type == 'linebreak').length;
            let curBrCount = this.chunk.chunkwords.filter(word => word.type == 'linebreak').length;
            if (brCount == 3 || curBrCount == 3) {
              data.push({type:'linebreak'});
              data.push({type:'linebreak'});
            } else if (this.chunk.newline || data.dialog) {
              data.chunkwords.push({type:'linebreak'});
            }

            this.chunks.unshift(data)

          } else if (mode == 1) {
            this.nextButton = false;

            this.chunk.chunkwords[this.chunk.chunkwords.length-1].hasSpace = true;
            let brCount = data.chunkwords.filter(word => word.type == 'linebreak').length;
            let curBrCount = this.chunk.chunkwords.filter(word => word.type == 'linebreak').length;
            if (brCount == 3 || curBrCount == 3) {
              data.unshift({type:'linebreak'});
            } else if (data.newline || data.dialog) {
              data.push({type:'linebreak'});
            }

            this.chunks.push(data)
          }
        }
      ).catch(error => {
        if (mode == -1) this.prevButton = false;
        else if (mode == 1) this.nextButton = false;
      })
    }
  }
}
</script>

<style @scoped>
  div.publicHeader {color: grey;padding-bottom:5px;}
  .alignright {text-align: right;}
  .colorBlue {color:mediumblue;}
  .colorBlue:hover {color:red;text-decoration: none;}
  .qMark {border:1px solid grey;border-radius:50%; padding: 0 6px; cursor:pointer;font-size: 12px;}
  .chunkHeadTooltip {text-align:left;}
  .chunkHeadTooltip .tooltip-inner {text-align:left;max-width: 500px;}
  .translate {color: grey;font-size:12px;}
</style>